import { EditUserFormSchema } from 'commons/userEdit';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useEditUserFormSchema = (
  phoneNumber: string,
  isGlobal: boolean,
  currentLang: string
) => {
  const { t } = useTranslationWithLang('userEditDelete');

  const schema = EditUserFormSchema(
    {
      RequiredMessage: t('Validate_Required'),
      MailMessage: t('Validate_Mail'),
      PhoneNumberMessage: t('Validate_PhoneNumber'),
      KanaMessage: t('Validate_Kana'),
      ConsentRequiredMessage: t('Validate_ConsentRequired'),
      MailRequiredMessage: t('Validate_MailRequired'),
      MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
      FullWidthMessage: t('Validate_FullWidth'),
    },
    phoneNumber,
    isGlobal,
    currentLang
  );
  return schema;
};
